function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05 20.136c-.372 0-.69-.14-.954-.42a1.422 1.422 0 01-.396-1.012V7.49c0-.46.154-.853.462-1.18.309-.327.68-.49 1.113-.49H9.3V2.715c0-.223.092-.398.277-.525C9.762 2.064 9.97 2 10.2 2h3.6c.23 0 .437.064.622.19a.604.604 0 01.278.526v3.102h.213L12 7.5l2.475 4.286v5.487h.9v-3.928L16 14.428l2.3-1.328v5.604c0 .394-.133.731-.397 1.012-.264.28-.582.42-.953.42a.953.953 0 01-.501.864H20v1H4v-1h3.55a.953.953 0 01-.5-.864zm8.358.68a.879.879 0 00.242.184H8.35a.953.953 0 00.5-.864h6.3c0 .27.087.498.26.68zM10.2 5.819h3.6V2.955h-3.6v2.863zM8.625 17.273h.9V8.682h-.9v8.59zm2.925 0h.9V8.682h-.9v8.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3 8.411V7.25c0-.394-.133-.73-.397-1.011a1.264 1.264 0 00-.953-.42h-.148L18.3 8.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.964 6.366l-2.598 1.5 3 5.196 2.598-1.5-3-5.196zM12 7.5l2 3.464 2 3.464 2.165-1.25 2.165-1.25-4-6.928L12 7.5z"
  }));
};
const SvgCheckedBag = styled(BaseComponent).withConfig({
  displayName: "CheckedBag__SvgCheckedBag",
  componentId: "sc-1c5a170-0"
})(["outline:none;"]);
SvgCheckedBag.isIcon = true;
export default SvgCheckedBag;